import { forwardRef, useEffect } from 'react';
import { Patterns, PhoneInput, usePhoneInput, IPhoneInputProps } from '@treezor/design-system';

import { useTranslation } from 'react-i18next';

import { TCountryCode } from '@/features/user/store/user.model';

const priorityCountries = ['FR', 'DE', 'ES', 'IT', 'BE', 'NL', 'LU', 'GP', 'MF', 'BL', 'MQ', 'RE', 'YT', 'PF'];

interface IContact extends IPhoneInputProps {
  name: string;
  value: string;
  label: string;
  initialValue?: string;
  initialCountry?: TCountryCode;
  handleValueChange: (value: string, key: string) => void;
  testId?: string;
}

export const Contact = forwardRef<HTMLInputElement, IContact>(
  ({ value, name, label, initialValue, initialCountry, handleValueChange, ...initialProps }: IContact, _) => {
    const { t } = useTranslation();

    const inputProps = usePhoneInput({ initialValue, handleInputChange: (value) => handleValueChange(value, name) });

    useEffect(() => {
      if (initialCountry && typeof initialCountry === 'string') {
        inputProps.onChange({ country: initialCountry });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialCountry]);

    useEffect(() => {
      if (initialValue && typeof initialValue === 'string') {
        inputProps.onChange({ value: initialValue });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialValue]);

    return (
      <PhoneInput
        name={name}
        label={label}
        error={!value || Patterns.phone.test(value) ? undefined : t('pages.dashboard.createUser.form.rules.phoneInput')}
        {...initialProps}
        {...inputProps}
        priorityCountries={priorityCountries}
        testId="input-phone"
      />
    );
  },
);

Contact.displayName = 'Contact';
